import firebase from 'firebase'

const config = {
  apiKey: "AIzaSyBiQONa7RRjXDxC-vzncpDk1xAwoJVVgfc",
  authDomain: "crowdsourcing-664f1.firebaseapp.com",
  databaseURL: "https://crowdsourcing-664f1.firebaseio.com",
  projectId: "crowdsourcing-664f1",
  storageBucket: "crowdsourcing-664f1.appspot.com",
  messagingSenderId: "1050847021579"
}

const fb = firebase.initializeApp(config)

export default {
  db: fb.database(),
  messaging: fb.messaging()
}



// WEBPACK FOOTER //
// ./src/fb.js